import { Box } from "@mui/material";
import DetailsOfMarketComponent from "../components/DetailsOfMarketComponent";

const DetailsOfMarket = () => {
  return (
    <Box>
      <DetailsOfMarketComponent />
    </Box>
  );
};

export default DetailsOfMarket;
